import React from 'react';
import { Chip } from '@mui/material';
import { ConsultationServiceType } from '@tassomutuo-backoffice/types';

interface IProps {
  serviceType: ConsultationServiceType;
}

export const SERVICE_TYPE_LABEL: Record<ConsultationServiceType, string> = {
  imprese: 'Imprese',
  agricoltura: 'Agricoltura',
  'fondo-garanzia': 'Fondo di garanzia',
  credito: 'Credito',
  assicurazioni: 'Assicurazioni',
  altro: 'Altro',
};

const SERVICE_TYPE_COLOR: Record<
  ConsultationServiceType,
  'default' | 'primary' | 'success' | 'warning' | 'info' | 'secondary'
> = {
  imprese: 'primary',
  agricoltura: 'success',
  'fondo-garanzia': 'info',
  credito: 'secondary',
  assicurazioni: 'warning',
  altro: 'default',
};

const ConsultationServiceTypeChip = ({ serviceType }: IProps) => {
  return (
    <Chip
      size="small"
      label={SERVICE_TYPE_LABEL[serviceType] ?? serviceType}
      color={SERVICE_TYPE_COLOR[serviceType] ?? 'default'}
      variant="outlined"
    />
  );
};

export default ConsultationServiceTypeChip;
